import Layout from "./layout";
import { Button, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 

const StoreManagementDashboard  = () => {
    const navigate = useNavigate();// Page linking using this 


    return(
        <>  
        <Layout/>
        <h1 className="title">Store Management </h1>
        <Box
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh', gap: '8em', }}
            >
                <Button 
                    variant="contained"
                    onClick={() => {navigate('/store-issue-kit') }}
                    sx={{backgroundColor: '#0A64A2', color: '#fff',left:'2em', borderRadius:'0.4em' ,marginRight: '2em',padding: '35px 77px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Issue Kit
                </Button>
                
                <Button
                    variant="contained" onClick={() => {navigate('/store-sale') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '36px 90px',fontSize: '14px',borderRadius:'0.4em' ,fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                   Sales
                </Button>
                <Button
                    variant="contained" onClick={() => {navigate('/issue-event&staff') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '37px 51px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Issue Products
                </Button>
                  <Button
                    variant="contained" onClick={() => {navigate('/erp-refundlog') }}
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '35px 56px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                   Refund Logs 
                </Button>
            </Box>

        </>
    )
}

export default StoreManagementDashboard; 

// select s.sales_id, s.student_id, s.sale_status_id, st.first_name,st.last_name, 
// 	st.father_name, st.mother_name, st.guardian_name , st.contact_no
// 	from sales as s 
// 	inner join student as st on 
// 	s.student_id = st.student_id